import CompanyCarousel from "../components/featured/home/CompanyCarousel";
import FAQHome from "../components/featured/home/FAQ_Home";
import HeroSection from "../components/featured/home/HeroSection";
import LaunchNext from "../components/featured/home/LaunchNext";
import ProblemSolution from "../components/featured/home/ProblemSolution";
import WorkFlow from "../components/featured/home/WorkFlow";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <CompanyCarousel />
      <ProblemSolution />
      <WorkFlow />
      <LaunchNext />
      <FAQHome />
      {/* <OfferModal /> */}
    </div>
  );
};

export default Home;
